type FoldAnimation = (selector: string, cb: () => unknown, duration?: number) => void;

const foldAnimation: FoldAnimation = (selector, cb, duration = 600) => {
    const element = document.querySelectorAll<HTMLInputElement>(selector)[0];
    const sectionHeight = element.scrollHeight;
    const elementTransition = `height ${duration}ms ease-out`;

    element.style.transition = '';

    requestAnimationFrame(() => {
        element.style.height = `${sectionHeight}px`;
        element.style.transition = elementTransition;
        element.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            element.style.height = `${0}px`;
            element.style.padding = `${0}px`;
        });
    });

    setTimeout(cb, duration);
};

export default foldAnimation;
